import { convertEwsIdToRestId } from 'owa-identifiers';
import { getEmailLink } from './getEmailLinkForNote';
import { LinkedEntity, LinkedEmail, EMAIL_ENTITY_TYPE } from 'owa-todo-types';

export default function getLinkedEmailEntity(linkedEmail: LinkedEmail): LinkedEntity {
    return {
        Id: convertEwsIdToRestId(linkedEmail.Id),
        WebLink: getEmailLink(linkedEmail.Id),
        EntityType: EMAIL_ENTITY_TYPE,
        EntitySubtype: linkedEmail.EntitySubtype,
        DisplayName: linkedEmail.DisplayName,
        Preview: {
            RestId: convertEwsIdToRestId(linkedEmail.Id),
        },
    };
}
